<template>
  <div v-if="data">
    <div class="card card-gallery">
      <div class="card-content is-relative px-0 py-0">
        <!-- <a @click="showModal = true"> -->
          <div v-show="loading" class="loading-overlay">
            <div class="loader"></div>
          </div>
          <figure v-if="large" class="thumbnail-image image">
            <img :src="large" @load="loading = false" />
          </figure>
        <!-- </a> -->
      </div>
    </div>
    <div v-if="data.thumbnail.length > 1" class="columns is-multiline is-centered is-mobile mt-2">
      <a v-for="(photo, index) in data.thumbnail" :key="index" @click="show(index)" class="column is-3">
        <figure class="thumbnail-image image has-background-white p-1 is-rounded">
          <img :src="photo" />
        </figure>
      </a>
    </div>
    <!-- <modal v-if="showModal" @close="showModal = false">
      <div slot="body" class="is-relative">
        <div v-show="loading" class="loading-overlay">
          <div class="loader"></div>
        </div>
        <figure class="image">
          <img :src="large" @load="loading = false" />
        </figure>
      </div>
    </modal> -->
  </div>
</template>

<script>
// import Modal from '../application/components/modal/index'
export default {
  // components: {
  //   Modal
  // },
  data () {
    return {
      data: null,
      current: 0,
      showModal: null,
      loading: false
    }
  },
  computed: {
    large () {
      if (!this.data) return
      return this.data.large[this.current]
    }
  },
  mounted () {
    this.data = JSON.parse(document.getElementById('gallery-data').innerHTML)
    window.addEventListener('keyup', this.handleKeyup)
  },
  beforeDestroy () {
    window.removeEventListener('keyup', this.handleKeyup)
  },
  methods: {
    show (index) {
      if (index === this.current) return

      this.loading = true
      this.current = index
    },
    expand () {
      this.loading = true
    },
    handleKeyup (e) {
      let current = this.current
      switch (e.key) {
      case 'ArrowLeft':
        current--
        break
      case 'ArrowRight':
        current++
        break
      }
      const max = this.data.large.length - 1
      if (current < 0) current = max
      if (current > max) current = 0
      this.show(current)
    }
  }
}
</script>
